import { createContext, FC, useEffect, useState } from 'react';

export enum ETheme {
  DARK = 'dark',
  LIGHT = 'light',
}

interface IThemeContext {
  theme: ETheme;
  setTheme: (theme: ETheme) => void;
}

const DEFAULT_STATE: IThemeContext = {
  theme: ETheme.LIGHT,
  setTheme: () => null,
};

export const ThemeContext = createContext<IThemeContext>(DEFAULT_STATE);

const THEME_KEY = 'theme';

export const ThemeProvider: FC = ({ children }) => {
  const [theme, setTheme] = useState<ETheme>(
    ((localStorage.getItem(THEME_KEY) as ETheme) || undefined) ?? ETheme.LIGHT
  );

  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
    document.body.className = theme;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
